import { combineReducers } from '@reduxjs/toolkit';
import errorCorrections from './reducers/errorCorrections/reducer';
import auth from './reducers/auth/reducer';
import user from './reducers/user/reducer';
import dashboard from './reducers/dashboard/reducer';
import monthlyFee from './reducers/monthlyFee/reducer';
import vatreport from './reducers/vatreport/reducer';
import swissPost from './reducers/swissPost/reducer';
import swedBank from './reducers/swedBank/reducer';
import mtd from './reducers/hmrc/reducer';
import gpsr from './reducers/gpsr/reducer';
import vatReimbursement from './reducers/vatReimbursement/reducer';
import salesProcessing from './reducers/salesProcessing/reducer';
import referrals from './reducers/referrals/reducer';
import emManagement from './reducers/emManagement/reducer';
import country from './reducers/country/reducer';
import currency from './reducers/currency/reducer';
import exchangeRates from './reducers/exchangeRates/reducer';
import taxDuties from './reducers/taxDuties/reducer';
import fiscalReports from './reducers/fiscalReports/reducer';
import accessManagement from './reducers/accessManagement/reducer';
import changeHistory from './reducers/changeHistory/reducer';
import emProductFileUploads from './reducers/emProductFileUploads/reducer';
import emVat from './reducers/emVat/reducer';
import emVatReports from './reducers/emVatReports/reducer';
import attachments from './reducers/attachments/reducer';
import eudr from './reducers/eudr/reducer';
import jotform from './reducers/jotform/reducer';
import userRoles from './reducers/userRoles/reducer';
import generalAttachments from './reducers/generalAttachments/reducer';
import emAutomationScripts from './reducers/emAutomationScripts/reducer';
import invoiceManagement from './reducers/invoiceManagement/reducer';
import orderManagement from './reducers/orderManagement/reducer';
import emails from './reducers/emails/reducer';
import sms from './reducers/sms/reducer';
import userMgmtConnectedEmerchants from './reducers/userMgmtConnectedEmerchants/reducer';
import emVatCorrectionsImport from './reducers/emVatCorrectionsImport/reducer';
import euDdp from './reducers/euDdp/reducer';
import shopifyStores from './reducers/shopifyStores/reducer';
import emSalesReports from './reducers/emSalesReports/reducer';
import easInfo from './reducers/easInfo/reducer';
import reports from './reducers/reports/reducer';
import easFee from './reducers/easFee/reducer';
import massPostSaleJobs from './reducers/massPostSaleJobs/reducer';
import superset from './reducers/superset/reducer';
import prp from './reducers/prp/reducer';
import supportedPostalOperators from './reducers/supportedPostalOperators/reducer';
import ppwr from './reducers/ppwr/reducer';
import pgSettings from './reducers/pgSettings/reducer';

const createRootReducer = () =>
	combineReducers({
		auth,
		user,
		dashboard,
		monthlyFee,
		vatreport,
		errorCorrections,
		swissPost,
		swedBank,
		mtd,
		gpsr,
		vatReimbursement,
		salesProcessing,
		referrals,
		emManagement,
		country,
		currency,
		exchangeRates,
		taxDuties,
		fiscalReports,
		accessManagement,
		changeHistory,
		emProductFileUploads,
		emVat,
		emVatReports,
		attachments,
		eudr,
		jotform,
		userRoles,
		generalAttachments,
		emAutomationScripts,
		invoiceManagement,
		orderManagement,
		emails,
		sms,
		userMgmtConnectedEmerchants,
		emVatCorrectionsImport,
		euDdp,
		shopifyStores,
		emSalesReports,
		easInfo,
		reports,
		easFee,
		massPostSaleJobs,
		superset,
		prp,
		supportedPostalOperators,
		ppwr,
		pgSettings,
	});

export default createRootReducer;
